import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "AvMed",
  shortName: "AvMed",
  slug: "avmed-insurance",
  seoTitle: "AvMed TMS Coverage | Neuro Wellness TMS",
  seoDescription:
    "Have AvMed insurance? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your AvMed plan in Coral Springs, FL.",
  seoKeywords:
    "AvMed TMS coverage, AvMed TMS therapy, AvMed depression treatment Florida, AvMed mental health benefits Coral Springs FL, AvMed SAINT TMS",
  planType: "Florida-based health insurance provider",
  planRegion: "Florida",
  memberTerm: "members",
  behavioralHealthTerm:
    "behavioral health benefits, including mental health services",
  planSpecificIntro:
    "AvMed is a Florida-based health insurance provider offering commercial, employer-sponsored, Medicare Advantage, and individual marketplace plans throughout the state. AvMed plans include behavioral health benefits that may cover TMS therapy and related neuromodulation treatments when medical necessity criteria are met. Because AvMed offers different plan types and network arrangements across Florida, coverage for TMS, accelerated protocols, and other advanced depression treatments varies significantly depending on your specific plan and network.",
  officialResourceUrl: "https://www.avmed.org/",
  officialResourceLabel: "AvMed official website",
};

export const AvMedInsurance = () => <InsurancePageTemplate config={config} />;
export default AvMedInsurance;
